/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import { FROM_0_TO_9999_3_DECIMAL_REGEX } from '#utils/string/regex';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';

import { STILL_RUN_FIELDS, SPIRIT_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const getStillRunTable = ({ values, errors }) => {
  const getStillRunValues = getSubStepValues(SPIRIT_SUBSTEPS_IDS.STILL_RUN, values, errors);
  return [
    {
      key: 'foreshots',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.stillRunTableColumns,
      fields: [
        {
          key: 'timeOnSpirit',
          Component: () => (
            <span className={styles.stillRunRowTitle}>
              {t(`${SPIRIT_SUBSTEPS_IDS.STILL_RUN}:${STILL_RUN_FIELDS.FORESHOTS_START_TIME}`)}
            </span>
          )
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.FORESHOTS_START_TIME, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          key: 'blankSpace1',
          Component: () => <div />
        },
        {
          key: 'blankSpace2',
          Component: () => <div />
        }
      ]
    },
    {
      key: 'firstRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.stillRunTableColumns,
      fields: [
        {
          key: 'timeOnSpirit',
          Component: () => (
            <span className={styles.stillRunRowTitle}>
              {t(`${SPIRIT_SUBSTEPS_IDS.STILL_RUN}:timeOnSpirit`)}
            </span>
          )
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.TIME_ON_SPIRIT, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.HYDROMETER_TIME_ON_SPIRIT, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.TEMPERATURE_TIME_ON_SPIRIT, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          measure: MEASURE_TYPES.TEMPERATURE,
          noMargin: true
        }
      ]
    },
    {
      key: 'secondRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.stillRunTableColumns,
      fields: [
        {
          key: 'timeOnSpirit',
          Component: () => (
            <span className={styles.stillRunRowTitle}>
              {t(`${SPIRIT_SUBSTEPS_IDS.STILL_RUN}:timeOffSpirit`)}
            </span>
          )
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.TIME_OFF_SPIRIT, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.HYDROMETER_TIME_OFF_SPIRIT, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.TEMPERATURE_TIME_OFF_SPIRIT, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          measure: MEASURE_TYPES.TEMPERATURE,
          noMargin: true
        }
      ]
    },
    {
      key: 'thirdRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.stillRunTableColumns,
      fields: [
        {
          key: 'timeOnSpirit',
          Component: () => (
            <span className={styles.stillRunRowTitle}>
              {t(`${SPIRIT_SUBSTEPS_IDS.STILL_RUN}:timeStillOff`)}
            </span>
          )
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.TIME_STILL_OFF, false),
          Component: Input,
          type: 'time',
          noMargin: true
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.HYDROMETER_TIME_STILL_OFF, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          noMargin: true
        },
        {
          ...getStillRunValues(STILL_RUN_FIELDS.TEMPERATURE_TIME_STILL_OFF, false),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_9999_3_DECIMAL_REGEX,
          measure: MEASURE_TYPES.TEMPERATURE,
          noMargin: true
        }
      ]
    }
  ];
};
